/* tslint:disable */

/**
 */
export class MembershipInput {
    key_case?: string;
    key_input?: string;
    key_search?: string;
}
